/**
 * @file DotPlot component entry point
 * @description Exports the DotPlot container component as the default export
 */

export { default } from "./DotPlotContainer";
